module.exports = __webpack_public_path__ + "img/logo.a9018c96.svg";